module.exports = "/images/cx.svg?454f99084b24d022b976470f6a9356b6";